<div class="container m-0 p-0">
  <div class="container-country">
    <div class=" container-country-title mx-0 px-0">
      <h1>Seleccione un País</h1>
      <div class="w-123"></div>
    </div>
    <div class="container-country-list mx-0 px-0 w-100">
      <div class="w-100 px-0 mx-0">

        <div class="row w-100 gap-3">
          @for (country of countryList; track country) {
          <div class="card-country cursor-pointer d-flex align-items-center gap-3 col-lg-3 col-md-4 col-sm-4"
            [attr.id]="'country-' + (country.code || $index)"
            (click)="onCountrySelected.emit(country)">
            <img class=" img-list" [src]="'./assets/icons/' + country.code + '.png'" alt="country" />
            <span class="text-country" mat-list-item>{{
              country.name
              }}
              <div class="text-country-sub"></div>
            </span>
          </div>
          }
        </div>

      </div>
    </div>
  </div>
</div>